"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
var _objects = require("libs/utils/objects");
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var LazyAppModule = require('./blueprint/LazyAppModule');
var resolvers = require('./blueprint/resolvers');
// predefined blueprints

// from the definition of modules, build routes
// routeValidator should take a route as a function and return the validated route, or a falsy value if not valid
var buildRoutesFromBlueprint = function buildRoutesFromBlueprint($routeProvider) {
  var blueprint = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var routeValidator = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function (route) {
    return route;
  };
  var vueTemplate = '/static/partials/vue-wrapper.html';
  _.each(blueprint.modules, function (module, moduleKey) {
    if (!module) {
      return;
    }

    // normalize module
    _.defaults(module, {
      sourceUrl: [],
      fullscreen: {}
    });
    module.sourceUrl = _.uniq(_.flatten([module.sourceUrl]));

    // patch up missing props in controllers
    var routePathPrefix = "/event/:eventId/modules/".concat(moduleKey);
    var controllers = module.controllers || {};

    // we need to create all routes at the end when all normalization has happened,
    // as angular does not keep a reference of the module but serialize the route
    // parameters.
    var allRoutes = [];
    _.each(controllers, function (controller, controllerKey) {
      // a custom route or path can be passed in as the controller's `route` or `path` property
      var finalPathEntry = controller.title ? controller.title : "".concat(controllerKey).concat(moduleKey);

      // set default values
      _.defaults(controller, {
        route: "".concat(routePathPrefix, "/").concat(controllerKey),
        path: ['event-instance-content', 'module', "module-".concat(moduleKey), "controller-".concat(controllerKey), "".concat(moduleKey, "#").concat(controllerKey), finalPathEntry],
        controller: _.noop,
        templateUrl: '/static/partials/undefined-module-template.html',
        fullscreen: {}
      });
      var isVue = Boolean(controller.componentName);

      // route could be an array so let's make it one regardless
      _.flatten([controller.route]).forEach(function (route) {
        // validate route
        route = routeValidator(route);
        if (!route) {
          return;
        }
        // if route is valid, continue
        allRoutes.push([route, _.extend({
          reloadOnSearch: false,
          template: controller.template,
          templateUrl: isVue ? vueTemplate : controller.templateUrl,
          controller: isVue ? 'VueWrapperCtrl' : controller.controller,
          resolve: controller.resolve || resolvers(controller.resolvers),
          path: controller.path,
          blueprintMetadata: {
            module: module,
            moduleKey: moduleKey,
            controller: controller,
            controllerKey: controllerKey
          }
        }, controller.routeOptions)]);
      });
    });

    // sort routes by specificity
    allRoutes.sort(function (_ref, _ref2) {
      var _ref3 = _slicedToArray(_ref, 1),
        route1 = _ref3[0];
      var _ref4 = _slicedToArray(_ref2, 1),
        route2 = _ref4[0];
      var route1Blocks = _.compact(route1.split('/'));
      var route2Blocks = _.compact(route2.split('/'));

      // compare routes, looking for params
      var compare = route1Blocks.reduce(function (prev, block, index) {
        if (prev !== 0) {
          return prev;
        }
        var matchingBlock = route2Blocks[index];
        if (!matchingBlock) {
          // route2 is shorter, consider more specific
          return 1;
        }
        if (block[0] === ':') {
          if (matchingBlock[0] !== ':') {
            // route2 does not have a parameter here, more specific
            return 1;
          }
          // both are params, consider it's equal
          return 0;
        }
        if (matchingBlock[0] === ':') {
          // route2 have a parameter, less specific
          return -1;
        }
        // use natural order
        return block.localeCompare(matchingBlock);
      }, 0);

      // if route2 is longer, it's less specific
      if (compare === 0 && route2Blocks.length > route1Blocks.length) {
        return -1;
      }
      return compare;
    });

    // only apply routes now
    _.each(allRoutes, function (_ref5) {
      var _ref6 = _slicedToArray(_ref5, 2),
        route = _ref6[0],
        param = _ref6[1];
      return $routeProvider.when(route, param);
    });
  });
};
var BluePrintServiceProvider = /*#__PURE__*/function () {
  BluePrintServiceProvider.$inject = ["$routeProvider", "$controllerProvider", "$compileProvider", "$filterProvider", "$provide", "$injector"];
  // http://blog.brunoscopelliti.com/how-to-defer-route-definition-in-an-angularjs-web-app

  /* @ngInject */
  function BluePrintServiceProvider($routeProvider, $controllerProvider, $compileProvider, $filterProvider, $provide, $injector) {
    var _this = this;
    _classCallCheck(this, BluePrintServiceProvider);
    this.blueprints = null;
    this.currentBlueprint = null;
    this.$routeProvider = $routeProvider;

    // the lazyModuleInstance keeps references to our providers so that we can add components post-bootstrap
    this.lazyModuleInstance = new LazyAppModule($controllerProvider, $compileProvider, $filterProvider, $provide, $injector);

    // attach backstage app module in the global scope
    window.getBackstageAppModule = window.BSTG.getAppModule = function () {
      return _this.lazyModuleInstance;
    };
  }

  /* @ngInject */
  _createClass(BluePrintServiceProvider, [{
    key: "$get",
    value: ["$http", "$filter", function $get($http, $filter) {
      var provider = this;
      // the default current blueprint.
      // Will be extend with global blueprint, and then event blueprint if needed.
      var currentBlueprint = {};
      var uppercaseFirstCharOfAllWords = $filter('uppercaseFirstCharOfAllWords');
      var uppercaseFirstChar = $filter('uppercaseFirstChar');

      // apply permission to blueprint, build routes. Will return a copy.
      var addBlueprint = function addBlueprint() {
        var blueprint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var routeValidator = arguments.length > 1 ? arguments[1] : undefined;
        buildRoutesFromBlueprint(provider.$routeProvider, blueprint, routeValidator);
        (0, _objects.deepExtend)(currentBlueprint, blueprint);
        return blueprint;
      };
      var service = {
        lazyAppModule: this.lazyModuleInstance,
        /**
         * Get the blueprint modules for the current event,
         * where restricted modules and controllers have been removed
         * @param {String} type if specified, returns modules of the given type
         * @returns {Object}
         */
        getModules: window.BSTG.services.blueprint.getModules.bind(window.BSTG.services.blueprint),
        /**
         * Get an ordered list of nav headings based on the list of defined modules
         * @param {String} type if specified, returns heading of the given type
         * @return {Array}
         */
        getNavHeadings: function getNavHeadings(type) {
          var modules = this.getModules(type);
          if (!modules) {
            return [];
          }
          return _.chain(modules).keys().map(function (moduleKey) {
            var moduleDescriptor = modules[moduleKey] || {};

            // find the first controller, this will be the route we link to
            //  and we'll have to take controller `order` into account to make sure
            //  we link to the correct "first" item
            var firstCtrlPair = _.chain(moduleDescriptor.controllers).pairs().sortBy(function (pair) {
              return pair[1] ? pair[1].order : undefined;
            }).first().value();
            if (!firstCtrlPair || !firstCtrlPair.length) {
              return;
            }
            var _firstCtrlPair = _slicedToArray(firstCtrlPair, 2),
              firstCtrlKey = _firstCtrlPair[0],
              firstCtrlDescriptor = _firstCtrlPair[1];

            // we selectively pick out the attributes of the module descriptor we wish to consider here
            // being selective at this point helps to keep the nav renderer encapsulated with a clean API
            var baseDescriptor = _.pick(moduleDescriptor, 'icon', 'order', 'hideNavUnlessActive');
            var title = moduleDescriptor.title || uppercaseFirstCharOfAllWords(moduleKey);

            // this could be an array (in the case where several routes are specified in a controller)
            var route = _.flatten([(firstCtrlDescriptor || {}).route])[0];
            return _.extend({}, firstCtrlDescriptor, baseDescriptor, {
              ctrlKey: firstCtrlKey,
              moduleKey: moduleKey,
              title: title,
              route: route
            });
          }).compact().sortBy('order').value();
        },
        /**
         * Get controllers headings for a module
         * @param {String} moduleKey
         * @return {Array}
         */
        getControllerHeadings: function getControllerHeadings(moduleKey) {
          var module = currentBlueprint.modules[moduleKey];
          if (!module) {
            return [];
          }
          var controllers = module.controllers || {};
          var list = _.keys(controllers).map(function (ctrlKey) {
            var ctrlDescriptor = controllers[ctrlKey];
            var substituteCtrlTitle = "".concat(ctrlKey, " ").concat((module.title || moduleKey || '').toLowerCase());
            var title = (ctrlDescriptor.title || substituteCtrlTitle).toLowerCase();
            return _.extend({}, ctrlDescriptor, {
              ctrlKey: ctrlKey,
              moduleKey: moduleKey,
              // exception for `Q&A` which would otherwise end up as `Q&a`
              title: title === 'q&a' ? title.toUpperCase() : uppercaseFirstChar(title),
              route: _.flatten([ctrlDescriptor.route])[0]
            });
          });
          return _.sortBy(list, 'order');
        },
        /**
         * Initialize the blueprint service (after a load or a change of users)
         * @return {Promise}
         */
        init: function init(global, eventId) {
          // init service with the global blueprint
          addBlueprint(global);
          // add the 404 route
          provider.$routeProvider.otherwise({
            redirectTo: eventId ? "/event/".concat(eventId) : '/'
          });
        },
        /**
         * Returns current blueprint
         *
         * @returns {Object} current blueprint
         */
        getBlueprint: function getBlueprint() {
          return currentBlueprint;
        }
      };
      return service;
    }]
  }]);
  return BluePrintServiceProvider;
}(); // # # # #
angular.module('backstage.services').provider('blueprintService', BluePrintServiceProvider);